/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LogoMicrosoftIcon64Regular = forwardRef('LogoMicrosoftIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 12.5A5.5 5.5 0 0 1 12.5 7h39a5.5 5.5 0 0 1 5.5 5.5v39a5.5 5.5 0 0 1-5.5 5.5h-39A5.5 5.5 0 0 1 7 51.5v-39Zm3 21v18a2.5 2.5 0 0 0 2.5 2.5h18V33.5H10Zm20.5-3H10v-18a2.5 2.5 0 0 1 2.5-2.5h18v20.5Zm3 3V54h18a2.5 2.5 0 0 0 2.5-2.5v-18H33.5Zm20.5-3H33.5V10h18a2.5 2.5 0 0 1 2.5 2.5v18Z" })));
});
